module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"projects":["Cryptogram Game","Either and Maybe in Typescript","D&D Assistant","GroupMe Electron App","Hello LA!"]},"de":{"projects":["Kryptogramm Spiel","Either und Maybe Entwurfsmuster mit Typescript","D&D Hilfskraft","GroupMe Electron App","Hallo LA!"]}}')
  delete Component.options._Ctor
}
